import React, { MouseEventHandler } from "react";
import styled from "styled-components";
import { Box, Flex, Icon } from "@thenounproject/lingo-core";

const Wrapper = styled(Flex).attrs({
  position: "absolute",
  top: "0",
  bottom: "0",
  left: "0",
  right: "0",
  zIndex: "5",
  justifyContent: "center",
  alignItems: "center",
})<{ visible: boolean }>`
  opacity: ${props => (props.visible ? 1 : 0)};
  pointer-events: ${props => (props.visible ? "auto" : "none")};
  transition: opacity 0.25s ease;
`;

const BlackOverlay = styled(Box).attrs<{ width?: string | number; height?: string | number }>(
  props => ({
    position: "absolute",
    top: "50%",
    height: props.height || "100%",
    left: "50%",
    width: props.width || "100%",
    background: "black",
  })
)`
  transform: translateX(-50%) translateY(-50%);
  opacity: 0.25;
`;

const ButtonIcon = styled(Icon)`
  filter: drop-shadow(0px 4px 14px rgba(42, 42, 42, 0.12))
    drop-shadow(0px 1px 4px rgba(42, 42, 42, 0.2));
`;

type Props = {
  mode: "play" | "pause";
  width?: string | number;
  height?: string | number;
  iconSize?: number;
  visible?: boolean;
  onClick?: MouseEventHandler;
};

const PlayPauseOverlay = ({
  mode,
  width,
  height,
  iconSize = 40,
  visible = true,
  onClick,
}: Props) => (
  <Wrapper visible={visible}>
    <BlackOverlay width={width} height={height} />
    <ButtonIcon
      aria-label={mode === "play" ? "Play video asset" : "Pause video asset"}
      data-testid={mode === "play" ? "play-icon" : "pause-icon"}
      iconId={mode === "play" ? "play-video" : "action.pause"}
      size={iconSize}
      fill="white"
      onClick={onClick}
    />
  </Wrapper>
);

export default PlayPauseOverlay;
